var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"main-menu"},[_c('div',{staticClass:"main-menu-inner"},[_c('router-view',{attrs:{"name":"pass-through-menu-client-apps"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }